import Text from "@components/atoms/Text";
import CustomLink from "@components/atoms/Link";
import { ResultRow } from "../ResultRow";
import { CalculatorResultProps } from "./CalculatorResult.types";
import { CALCULATOR_TABS, RESULT_LABELS } from "./constants";
import styles from "./CalculatorResult.module.scss";

export const CalculatorResult = ({
  activeTab,
  result,
  slug,
  onSeeOptions,
  model,
  brand,
  cityName,
  carAvailability,
  pageType,
}: CalculatorResultProps) => {
  const isEMITab = activeTab === CALCULATOR_TABS.EMI;
  const headline = isEMITab
    ? RESULT_LABELS.loanAmount
    : RESULT_LABELS.monthlyEMI;
  const value = isEMITab ? result.calculatedLoanAmount : result.calculatedEMI;

  const link = `/cars/${slug}/variants?maxPrice=${result?.maxPrice}`;

  return (
    <div className={styles.calculatorResult}>
      <div className={styles.headlineRow}>
        <Text className={styles.headlineText}>{headline}</Text>
        <Text className={styles.valueText}>
          ₹{value?.toLocaleString()}
          {!isEMITab && "/month"}
        </Text>
      </div>

      <div className={styles.divider} />

      <ResultRow
        label={
          isEMITab
            ? `EMI @ ${result?.interest}%`
            : `Loan amount @ ${result?.interest}%`
        }
        value={isEMITab ? result?.emi : result?.loan}
      />

      <ResultRow label="Down payment" value={result.downpayment} />

      <div className={styles.divider} />

      {result?.variantsCount ? (
        <div>
          <Text className={styles.descriptionText}>
            Awesome! Your budget fits perfectly for
          </Text>
          <Text className={styles.variantsText}>
            {`${result?.variantsCount} ${brand} ${model} variants`}
          </Text>
        </div>
      ) : (
        <div>
          <Text className={styles.descriptionText}>
            {`Sorry, your budget doesn&rsquo;t fit any of the variants for ${brand} ${model}`}
          </Text>
        </div>
      )}

      {!!result?.variantsCount && (
        <CustomLink
          className={styles.seeOptionsButton}
          onClick={onSeeOptions}
          ariaLabel="See all car options"
          href={link}
          segmentEventProps={{
            eventName: "action",
            pageType: pageType,
            eventProperties: {
              action_type: "tap_btn",
              action_name: "tap_see_loan_options",
              selected_value: isEMITab ? "EMI I can pay" : "Loan amount I need",
              car_availability: carAvailability,
              city_name: cityName,
              vehicle_make: brand,
              vehicle_model: model,
            },
          }}
        >
          See all my options
        </CustomLink>
      )}
    </div>
  );
};
